// React
import React from 'react';
import {useState} from 'react';

// MUI
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import {AdvancedSection} from './AdvancedSection';

export default function EcProperties(props) {
    const [, setValue] = useState(props.node.fb.pollPeriod);
    const [, setDelayedStart] = useState(props.node.fb.delayedStart);
    function handleChange(e) {
        props.node.fb.pollPeriod = e.target.valueAsNumber;
        setValue(e.target.value);
        props.changeFunc(props.node);
    }
    function handleDelayedStartChange(e) {
        props.node.fb.delayedStart = e.target.valueAsNumber;
        setDelayedStart(e.target.value);
        props.changeFunc(props.node);
    }
    return (
        <Box sx={{display:'flex', flexDirection:'column', padding:2}}>
            {/* {props.node.fb.nodeType} */}
            <TextField label="Read frequency" value={props.node.fb.pollPeriod} helperText="seconds" type="number" onChange={handleChange}/>
            <AdvancedSection>
                <TextField label="Delayed start" value={props.node.fb.delayedStart} helperText="seconds" type="number" onChange={handleDelayedStartChange}/>
            </AdvancedSection>
        </Box>
    )
};

export {EcProperties};
// time in seconds
export const EcPropertiesExtension = {pollPeriod:30, delayedStart:0};
